import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { EntityHeaderLayoutBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * En-tête des pages d'entité du catalogue.
 *
 * `entity-header-layout:catalog/platform` : notre en-tête, sans « Lifecycle »
 * et en français — voir `PlatformEntityHeader`. Sans filtre, il s'applique à
 * tous les kinds.
 *
 * `page:catalog/entity` avec `noHeader` : la page native rendait, au-dessus de
 * l'en-tête d'entité, le bandeau du plugin — « Catalog » tout seul, qui
 * doublait l'étiquette de kind et le menu latéral. Même surcharge que
 * `page:rbac` (voir `modules/overrides`). `catalogEntityPage` est construit
 * par `makeWithOverrides`, mais les `params` d'une surcharge sont bien
 * fusionnés dans ceux qu'il passe à `PageBlueprint`.
 */
const platformEntityHeader = EntityHeaderLayoutBlueprint.make({
  name: 'platform',
  params: {
    loader: () =>
      import('./PlatformEntityHeader').then(m => m.PlatformEntityHeader),
  },
});

const entityPageSansBandeau = catalogPlugin
  .getExtension('page:catalog/entity')
  .override({ params: { noHeader: true } });

export const entityHeaderModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [platformEntityHeader, entityPageSansBandeau],
});
